/**
 * Browser-specific HTMLCanvasElement prototype extensions
 *
 * These extensions use browser-only APIs (HTMLCanvasElement, document.createElement)
 * and cannot be moved to switch-core. Other platforms will need their own implementations.
 */

// Required for TypeScript module augmentation
export {};

declare global {
  interface HTMLCanvasElement {
    cropCanvasToSquare(squareSize: number): HTMLCanvasElement;
  }
}

HTMLCanvasElement.prototype.cropCanvasToSquare = function cropCanvasToSquare(
  squareSize: number,
): HTMLCanvasElement {
  // Create a new square canvas
  const squareCanvas = document.createElement("canvas");
  squareCanvas.width = squareSize;
  squareCanvas.height = squareSize;
  const originalCanvas = this;

  // Get the drawing context for both canvases
  // const originalContext = originalCanvas.getContext("2d");
  const squareContext = squareCanvas.getContext("2d");

  // Calculate the dimensions for cropping while preserving the aspect ratio
  const aspectRatio = originalCanvas.width / originalCanvas.height;

  let sourceX = 0;
  let sourceY = 0;
  let sourceWidth = originalCanvas.width;
  let sourceHeight = originalCanvas.height;

  if (aspectRatio > 1) {
    // Landscape orientation (wider than tall)
    sourceWidth = originalCanvas.height * aspectRatio;
    sourceX = (originalCanvas.width - sourceWidth) / 2;
  } else if (aspectRatio < 1) {
    // Portrait orientation (taller than wide)
    sourceHeight = originalCanvas.width / aspectRatio;
    sourceY = (originalCanvas.height - sourceHeight) / 2;
  }

  // Draw the original canvas onto the square canvas, preserving the aspect ratio
  // @ts-ignore
  squareContext.drawImage(
    originalCanvas,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight, // Source rectangle with aspect ratio
    0,
    0,
    squareSize,
    squareSize, // Destination rectangle (square)
  );

  return squareCanvas;
};
